import CashCollectionBase from './base/CashCollectionBase';
import CashCollectionTypeEnum from './enum/CashCollectionTypeEnum';

/**
 * @class CashCollection
 * @extends CashCollectionBase
 */
class CashCollection extends CashCollectionBase {
  get typeDisplayName() {
    const typeMap = {
      [CashCollectionTypeEnum.VGT_DROP]: 'VGT Drop',
      [CashCollectionTypeEnum.RT_BV_DROP]: 'BV Drop',
      [CashCollectionTypeEnum.RT_AUDIT]: 'RT Audit',
    }

    return typeMap[this.type]
  }
}

export default CashCollection;
